import AuthenticationButton from './AuthenticationButton';

const AuthNav = () => (
  <div className="navbar-nav">
    <AuthenticationButton />
  </div>
);

export default AuthNav;
